module.exports = __webpack_public_path__ + "80e67db746d7a84457d8cd88c0286bfc.png";